<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    //this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.doctorsSchedule.totalItems / this.filters.pageSize
      );
    },
    doctorsSchedule() {
      return this.$store.state.doctorsSchedule.doctorsSchedule;
    },
    daysOfWeeks(){
      return [
        {value:1 , label:"السبت "},
        {value:2 , label:"الاحد"},
        {value:3 , label:"الاثنين"},
        {value:4 , label:"الثلاثاء"},
        {value:5 , label:"الاربعاء"},
        {value:6 , label:"الخميس"},
        {value:7 , label:"الجمعة"},
      ]
    },   
     doctors(){
      return [
        {value:1 , label:"د. أحمد على "},
        {value:2 , label:"د. الهادي المختار"},
        
      ]
    },
  },

  data() {
    return {
      view: 0,

      filters: {
        page: 1,
        pageSize: 10,

        day: null,
        doctorId: null,
      },
      headers: [
        { text: 'الطبيب', value: 'doctorName' },
        { text: 'اليوم', value: 'day' },
        { text: 'رقم الغرفة', value: 'roomNo' },
        { text: 'مـن', value: 'fromTime' },
        { text: 'الـى', value: 'toTime' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
   
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("patients/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
    ////  this.view = 3;
      // Implement view logic
    },   
     editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`patients/delete`, this.itemId);
    },
    back(){
      this.view = 0;
    }
  },
};
</script>

<style scoped>
</style>